export { isHuaweiWebview } from './is-huawei-webview';
